"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var context_1 = require("../../../context");
var utils_1 = require("../../../utils");
var Card_1 = require("../../Card");
var FormControl_1 = __importDefault(require("../../FormControl"));
var Select_1 = __importDefault(require("../../Select"));
var Tabs_1 = require("../../Tabs/Tabs");
var Fields_1 = require("../Fields");
var errorKeys = ['nhs_number', 'gp_id'];
var MedicalDetailsForm = function (_a) {
    var tabId = _a.tabId;
    var _b = context_1.useSemantics(), trans = _b.trans, options = _b.options;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(errors, errorKeys)); }, [errors]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('optiiva::headings.medical'), subHeading: trans('optiiva::headings.details') },
        react_1.default.createElement(Fields_1.NHSNumberInput, null),
        react_1.default.createElement(FormControl_1.default, { errors: errors.gp_id, dusk: "gp-id-field", label: trans('optiiva::labels.gp'), flush: true },
            react_1.default.createElement(Select_1.default, { width: "md", options: options.gps(), name: "gp_id" }))));
};
exports.default = MedicalDetailsForm;
//# sourceMappingURL=MedicalDetailsForm.js.map